import { BondSort } from './global';

export const initialBondSortContext: BondSort = { sortColumn: 'S_ACC.CREATE_AT', sortDirection: 'DESC' };
